export type DatasetExtent = [number, number, number, number];

/** Wrapped worlds and antimeridian views must query the same stored records. */
export function datasetExtent(extent: number[]): DatasetExtent {
  const south = Math.max(-90, extent[1]); const north = Math.min(90, extent[3]);
  if (extent[2] - extent[0] >= 360) return [-180, south, 180, north];
  const longitude = (value: number) => ((value + 180) % 360 + 360) % 360 - 180;
  return [longitude(extent[0]), south, longitude(extent[2]), north];
}

export function datasetIntersects(a: DatasetExtent | null, b: DatasetExtent): boolean {
  if (!a || a[1] > b[3] || a[3] < b[1]) return false;
  return b[0] > b[2] ? a[0] <= b[2] || a[2] >= b[0] : a[0] <= b[2] && a[2] >= b[0];
}
